import './LayoutBreadcrumb.scss';
import React, { memo, PropsWithChildren } from 'react';

export const LayoutBreadcrumb = memo(({ children }: PropsWithChildren) => (
  <div className="bp-layout-breadcrumb">
    {children}
  </div>
));
